import React from 'react';
import { ShieldExclamationIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';

export default function AccessDenied({ userEmail, onLogout }) {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="text-center max-w-md">
        <ShieldExclamationIcon className="h-16 w-16 text-red-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-100 mb-2">
          Access Denied
        </h1>
        <p className="text-gray-400 mb-4">
          You do not have permission to access the Blue365Signal Portal.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          Your account{' '}
          <span className="text-gray-300 font-mono">{userEmail}</span>{' '}
          is not a member of a security group for any MSP in this portal. Contact
          your administrator to be added to your MSP's portal group.
        </p>
        <button
          onClick={onLogout}
          className="inline-flex items-center gap-2 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-gray-200 font-medium rounded-lg transition-colors"
        >
          <ArrowRightStartOnRectangleIcon className="h-5 w-5" />
          Sign out
        </button>
      </div>
    </div>
  );
}
